import { html as e, when as t } from "@microsoft/fast-element";
const l = (a) => {
  const n = e.partial(a.prefix);
  return e`
    <div
      class="control"
      part="control"
      @click="${(s) => s.stepIconClicked()}"
      @keypress="${(s, c) => s.stepIconKeyPressed(c.event)}"
    >
      <div class="step-icon-container" tabindex="0">
        <div class="step-icon">
          ${t(
    (s) => s.status === "complete",
    e`
              <${n}-icon name="check" class="icon"></${n}-icon>`
  )}
          ${t(
    (s) => s.status === "incomplete",
    e`
              <${n}-icon
                name="exclamation-triangle"
                class="icon"
              ></${n}-icon>`
  )}
          ${t(
    (s) => s.status === "default",
    e`<span class="step-icon-index">${(s) => s.index + 1} </span>`
  )}
        </div>
        <div class="label-container">
          <span class="label"> ${(s) => s.label} </span>
          ${t(
    (s) => s.optional,
    e` <span class="subtitle"> Optional </span>`
  )}
        </div>
      </div>
      <slot></slot>
    </div>
  `;
};
export {
  l as stepIconTemplate
};
